import { render, staticRenderFns } from "./CurriculumVitaeScholarshipAwardDiscipline.vue?vue&type=template&id=128bb37e&"
import script from "./CurriculumVitaeScholarshipAwardDiscipline.vue?vue&type=script&lang=js&"
export * from "./CurriculumVitaeScholarshipAwardDiscipline.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumVitaeScholarshipAwardDiscipline.vue?vue&type=style&index=0&id=128bb37e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports